// House Plotly template. Keep in step with scripts/blog/stylome_plotly.py,
// which renders the PNG fallbacks with the same values.
const ink = "#17201e";
const muted = "#56615d";
const line = "#cfcac0";

export const chartColors = {
  accent: "#173f3a",
  human: "#17604f",
  mixed: "#87580d",
  ai: "#9f4039",
  muted,
};

export const houseTemplate = {
  layout: {
    font: { family: "IBM Plex Sans, sans-serif", size: 14, color: ink },
    title: {
      font: { family: "Literata, Georgia, serif", size: 18 },
      x: 0,
      xanchor: "left",
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    colorway: [
      chartColors.accent,
      chartColors.mixed,
      muted,
      chartColors.ai,
      chartColors.human,
    ],
    margin: { l: 56, r: 16, t: 40, b: 48 },
    xaxis: {
      gridcolor: line,
      linecolor: ink,
      zerolinecolor: line,
      ticks: "outside",
      tickcolor: ink,
      automargin: true,
    },
    yaxis: {
      gridcolor: line,
      linecolor: ink,
      zerolinecolor: line,
      ticks: "outside",
      tickcolor: ink,
      automargin: true,
    },
    legend: {
      orientation: "h",
      x: 0,
      xanchor: "left",
      y: 1.02,
      yanchor: "bottom",
      traceorder: "normal",
      bgcolor: "rgba(0,0,0,0)",
    },
    hoverlabel: {
      bgcolor: "#fbfaf6",
      bordercolor: ink,
      font: { family: "IBM Plex Mono, monospace", color: ink },
    },
  },
};
